import React, { useState, useContext, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import i18next from 'i18next';
import PropTypes from 'prop-types'
import * as pageSourceCode from '@scripts/PageSourceCode';
import { approvalType } from '@scripts/CentralApprovalTypeHelper';
import RequestDetailBankDisplay from './RequestDetailBankDisplay'
import RequestDetailShiftDisplay from './RequestDetailShiftDisplay'
import RequestDetailLeaveDisplay from './RequestDetailLeaveDisplay'
import RequestDetailVacationDisplay from './RequestDetailVacationDisplay'
import { saveLeaveApprovalCentralRequest, saveShiftExchangeRequestComment } from '@actionsSup/approvalCentral';
import { messagesTypes } from '@utils/constants';
import { MessageContext } from '@/MessageProvider';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RequestDetail(props) {
    const classes = useStyles();
    const { dispatch } = useContext(MessageContext);    

    const {
        pageSource,
        load,
        onClose,
        open,
        data,
        isPosting,
        setIsPosting,
        handleRequest,
        getIsLeaveRequest,
        getIsActionButtonShown,
        getIsDenyButtonEnabled,
        getIsApproveButtonEnabled,
        comment,
        setComment
    } = props;

    const [isToReplace, setIsToReplace] = useState(data.isToReplace);

    useEffect(() => {
        setComment(pageSource == pageSourceCode.CALENDAR ? data.approverComment : data.request.approverComment);
    }, []);

    const handleSaveClick = async (approverComment) => {

        setIsPosting(true);
        let result = undefined;
        
        if (data.approvalType === approvalType.SHIFT_EXCHANGE) {            
            result = await saveShiftExchangeRequestComment(data.originTableNameId, approverComment);
        } else {            
            result = await saveLeaveApprovalCentralRequest(data.originTableNameId, isToReplace, approverComment);
        }
        
        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
            setIsPosting(false);
            return;
        } else if (result.statusCode === 0) {
            dispatch({ type: messagesTypes.SUCCESS, payload: i18next.t('approvalCentral:message.updateSuccess') });
        } else if (result.statusCode === -1) {
            dispatch({ type: messagesTypes.CUSTOMERROR, payload: result.message });
            setIsPosting(false);
            return;
        }

        setIsPosting(false);
        onClose();
        load();
    }

    const handleClose = () => {
        setIsPosting(false);
        onClose();
    };
    
    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {i18next.t("approvalCentral:tabPanelDetail.detailRequest")}
                    </Typography>
                </Toolbar>
            </AppBar>
            {data.approvalType === approvalType.BANK_ACCOUNT_CHANGE && <RequestDetailBankDisplay data={data} dataRequest={data.request} isToReplace={isToReplace} setIsToReplace={setIsToReplace} isPosting={isPosting} handleRequest={handleRequest} getIsLeaveRequest={getIsLeaveRequest} getIsActionButtonShown={getIsActionButtonShown}  getIsDenyButtonEnabled={getIsDenyButtonEnabled} getIsApproveButtonEnabled={getIsApproveButtonEnabled} />}
            {data.approvalType === approvalType.SHIFT_EXCHANGE && <RequestDetailShiftDisplay data={data} dataRequest={data.request} isToReplace={isToReplace} setIsToReplace={setIsToReplace} comment={comment} setComment={setComment} saveClick={handleSaveClick} isPosting={isPosting} handleRequest={handleRequest} getIsLeaveRequest={getIsLeaveRequest} getIsActionButtonShown={getIsActionButtonShown} getIsDenyButtonEnabled={getIsDenyButtonEnabled} getIsApproveButtonEnabled={getIsApproveButtonEnabled} />}
            {(data.approvalType === approvalType.LEAVE || data.approvalType === approvalType.LEAVE_AZUR) && <RequestDetailLeaveDisplay pageSource={pageSource} data={data} dataRequest={pageSource == pageSourceCode.CALENDAR ? data : data.request} isToReplace={isToReplace} setIsToReplace={setIsToReplace} comment={comment} setComment={setComment} saveClick={handleSaveClick} isPosting={isPosting} handleRequest={handleRequest} getIsLeaveRequest={getIsLeaveRequest} getIsActionButtonShown={getIsActionButtonShown}  getIsDenyButtonEnabled={getIsDenyButtonEnabled} getIsApproveButtonEnabled={getIsApproveButtonEnabled} />}
            {(data.approvalType === approvalType.VACATION || data.approvalType === approvalType.VACATION_AZUR) && <RequestDetailVacationDisplay pageSource={pageSource} data={data} dataRequest={pageSource == pageSourceCode.CALENDAR ? data : data.request} isToReplace={isToReplace} setIsToReplace={setIsToReplace} comment={comment} setComment={setComment} saveClick={handleSaveClick} isPosting={isPosting} handleRequest={handleRequest} getIsLeaveRequest={getIsLeaveRequest} getIsActionButtonShown={getIsActionButtonShown}  getIsDenyButtonEnabled={getIsDenyButtonEnabled} getIsApproveButtonEnabled={getIsApproveButtonEnabled} />}
        </Dialog>
    )
}

RequestDetail.propTypes = {
    data: PropTypes.object.isRequired
}